// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../formatDistance/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var formatDistanceWithOptions = convertToFP(fn, 3);
export default formatDistanceWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/formatDistanceWithOptions/index.js
// module id = 874
// module chunks = 0